import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

export default function LeadtoolLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isPendingError = error.includes("schválení") || error.includes("zamítnut");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/supplier/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Chyba při přihlášení");
      localStorage.setItem("supplierToken", data.token);
      localStorage.setItem("supplierData", JSON.stringify(data.supplier));
      navigate("/leadtool/dashboard");
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-6">
          <img src="/vyjedname-logo.png" alt="Vyjednáme" className="h-9 object-contain" />
          <div className="h-8 w-px bg-gray-300" />
          <img src="/vodafone-partner-business.png" alt="Vodafone Business Partner" className="h-9 object-contain" />
        </div>
      </header>

      {/* Main */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="bg-gradient-to-r from-red-600 to-red-700 px-8 py-8 text-center">
              <h1 className="text-2xl font-bold text-white">Leadtool portál</h1>
              <p className="text-red-100 mt-1 text-sm">Partnerský leadový portál Vyjednáme</p>
            </div>

            <form onSubmit={handleSubmit} className="p-8 space-y-5">
              {error && (
                <div className={`border px-4 py-3 rounded-xl text-sm ${isPendingError ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-red-50 border-red-200 text-red-700'}`}>{error}</div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                  autoFocus
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Heslo</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white font-semibold py-3 rounded-xl transition-colors text-sm"
              >
                {loading ? "Přihlašuji..." : "Přihlásit se"}
              </button>

              <p className="text-center text-sm text-gray-500">
                Ještě nemáte účet?{" "}
                <button type="button" onClick={() => navigate("/leadtool/register")} className="text-red-600 hover:text-red-700 font-medium">
                  Zaregistrujte se
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
